import React, { Component } from 'react';

const STATE_CODE = {
  DEFAULT: '環境測試',
  RUNING: '檢查中...',
  FINE: '環境正常',
}

class CheckinDebugBtn extends Component {
  state = {
    label: STATE_CODE.DEFAULT
  }

  btnClass = () => {
    let color;

    switch (this.state.label) {
      case STATE_CODE.DEFAULT:
      case STATE_CODE.RUNING:
        color = 'primary'
        break;
      case STATE_CODE.FINE:
        color = 'success'
        break;
      default:
        color = 'danger'
    }

    return `btn btn-${color}`
  }

  changeLabel = (label) => {
    this.setState({label})
  }

  startChecking = () => {
    this.changeLabel(STATE_CODE.RUNING);
    
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.changeLabel(STATE_CODE.FINE);
        },
        (err) => {
          console.log(err);
          this.changeLabel('錯誤代碼: ' + (err.code || 0)) 
        },
        {
          timeout: 10000
        }
      )
    } else {
      this.changeLabel('錯誤代碼: -1')
    }
  }

  render() {
    return (
      <button className={this.btnClass()} onClick={this.startChecking}>
        {this.state.label}
      </button>
    )
  }
}

export default CheckinDebugBtn;


// WEBPACK FOOTER //
// ./src/components/Checkin/CheckinDebugBtn.js